<!-- Mobile viewports -->
<div class="d-block d-sm-none documentsummary-details-mobile" id="summary">
    <ng-container *ngIf="xbrlDetails && xbrlDetails.length > 0">
        <div class="rounded-corners">
            <table class="mat-mdc-table">
                <tr class="mat-mdc-header-row mobile text-break">
                    <th class="mat-mdc-header-cell mdc-data-table__header-cell table-title" colspan="2">
                        {{getDocumentName()}}</th>
                </tr>
                <ng-container *ngFor="let xbrlDetail of xbrlDetails">
                    <tr class="mat-mdc-row mobile cols-12 text-break">
                        <td class="mat-mdc-cell mdc-data-table__cell align-middle col-4">
                            <span class="column-text-mobile" translate="Request.View.Summary.{{xbrlDetail.key}}"></span><br />
                            {{xbrlDetail.value}}
                        </td>
                    </tr>
                </ng-container>
            </table>
        </div>
    </ng-container>

</div>

<!-- Desktop viewports -->
<div class="d-none d-sm-block documentsummary-details" id="summary">
    <ng-container *ngIf="xbrlDetails && xbrlDetails.length > 0">
        <div class="rounded-corners">
            <table class="mat-mdc-table">
                <tr class="mat-mdc-header-row text-break">
                    <th class="mat-mdc-header-cell mdc-data-table__header-cell table-title" colspan="2">
                        {{getDocumentName()}}</th>
                </tr>
                <ng-container *ngFor="let xbrlDetail of xbrlDetails">
                    <tr class="mat-mdc-row cols-12 text-break">
                        <td class="mat-mdc-cell mdc-data-table__cell align-middle col-4 column-text"
                            translate="Request.View.Summary.{{xbrlDetail.key}}"></td>
                        <td class="mat-mdc-cell mdc-data-table__cell align-middle col-8">{{xbrlDetail.value}}</td>
                    </tr>
                </ng-container>
            </table>
        </div>
    </ng-container>

</div>